module.exports = __webpack_public_path__ + "media/hph-24-04_experiential-learning.4d5ee4c2.mp4";